import { createApp } from 'vue';
import plannedProjectAreaApp from '@/app/views/planned-project-area/planned-project-area.vue';
import store from '@/app/store';

function init(): void {
  const plannedProjectAreaEl = document.getElementById('planned-project-area');
  if (plannedProjectAreaEl) {
    const app = createApp(plannedProjectAreaApp);
    app.use(store);
    app.provide('config', SSENT);
    app.provide('storeName', 'plannedProjectArea');
    app.mount(plannedProjectAreaEl);
  }
}

export default init;
